module.exports = __webpack_public_path__ + "img/9791158883966.91c1170a.jpg";